const MAIN_TITLE = document.title

export default class TabTitle {
  #title = MAIN_TITLE || ''
  #totalMnemonics = 0

  constructor(title) {
    if (title && typeof title === 'string') {
      this.#title = title || MAIN_TITLE

      document.title = this.#title
    }
  }

  addMNemonics(total) {
    if (this.#totalMnemonics === total) return true
    this.#totalMnemonics = total

    const text = this.#totalMnemonics > 0
      ? `(${this.#totalMnemonics > 99 ? '+99' : this.#totalMnemonics}) `
      : ''


    document.title = `${text}${this.#title}`
  }
}